import apiService from "../common/commonApi";

export const myLeaveRequest = {};

myLeaveRequest.listLeaveType = async (param) => {
    return apiService.Get("getLeaveTypes", param);
};

myLeaveRequest.summaryOfLeave = async (param) => {
    return apiService.Get("mySummaryOfLeaveType", param);
};

myLeaveRequest.listRequest = async (param) => {
    return apiService.Get("myLeaveRequestList", param);
};

myLeaveRequest.updateIsConfirm = async (param) => {
    return apiService.Post("updateIsConfirm", param);
};
